import { OFFENSE_TYPE } from "./constantValues";

export const isInvestigationAllowed = (
  offence_type: string,
  date_of_offense: string
) => {
  if (!offence_type || !date_of_offense) return false;

  const offenseType = offence_type.toLowerCase();
  const offenseDate = new Date(date_of_offense);
  const currentDate = new Date();

  const timeDiff = currentDate.getTime() - offenseDate.getTime();
  const dayDiff = timeDiff / (1000 * 3600 * 24);

  if (offenseType.includes(OFFENSE_TYPE.GRAVE_OFFENSE) && dayDiff <= 60) {
    return true;
  }

  if (offenseType.includes(OFFENSE_TYPE.MEDIUM_OFFENSE) && dayDiff <= 30) {
    return true;
  }

  if (offenseType.includes(OFFENSE_TYPE.PITY_OFFENSE)) {
    return dayDiff <= 21;
  }

  return false;
};
